import {
  ApplicationConfig,
  provideZonelessChangeDetection,
  isDevMode,
  inject,
  ErrorHandler
} from '@angular/core';
import { ActivatedRoute, Router, provideRouter, withComponentInputBinding } from '@angular/router';
import { HttpClient, provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideClientHydration, withEventReplay, withIncrementalHydration } from '@angular/platform-browser';
import { provideTranslateService, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideServiceWorker } from '@angular/service-worker';
import { GlobalErrorHandler } from './core/providers/handlers/global-error.handler';
import { loggingInterceptor } from './core/providers/interceptors/logging/logging.interceptor';
import { cachingInterceptor } from './core/providers/interceptors/caching/caching.interceptor';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';

// ENVs
import { ENV } from '../environments/environment';
import { setContext } from '@apollo/client/link/context';


const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (httpClient: HttpClient) =>
  new TranslateHttpLoader(httpClient as any, './i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    provideRouter(routes, withComponentInputBinding()),
    provideZonelessChangeDetection(), provideAnimationsAsync(),
    provideHttpClient(withFetch(), withInterceptors([ loggingInterceptor, cachingInterceptor ])),
    provideApollo(() => {
      const httpLink = inject(HttpLink),
            activatedRoute = inject(ActivatedRoute),
            router = inject(Router);

      const context = setContext((operation, context) => {
        const tenant = (activatedRoute.snapshot.paramMap.get('country') || router.url.split('/')[2] || 'CL').toUpperCase();

      /*  if (!tenant) {
          return { headers: { 'x-tenant-app': 'SOD', 'x-tenant-id': 'CL' }};

        } else { */return { headers: { 'x-tenant-app': 'SOD', 'x-tenant-id': tenant }}; /*}*/
      });

      return {
        link: ApolloLink.from([context, httpLink.create({ uri: ENV.GQL.URI })]),
        cache: new InMemoryCache(),
        // other options ...
      };
    }),
    provideClientHydration(withIncrementalHydration(), withEventReplay()),
    provideTranslateService({
      defaultLanguage: 'es-CL',
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [ HttpClient ],
      },
    }),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ]
};
